"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var v3_exports = {};
__export(v3_exports, {
  blue: () => import_legacy.blue,
  blueDark: () => import_legacy.blueDark,
  gray: () => import_legacy8.gray,
  grayDark: () => import_legacy8.grayDark,
  green: () => import_legacy2.green,
  greenDark: () => import_legacy2.greenDark,
  orange: () => import_legacy4.orange,
  orangeDark: () => import_legacy4.orangeDark,
  pink: () => import_legacy6.pink,
  pinkDark: () => import_legacy6.pinkDark,
  purple: () => import_legacy7.purple,
  purpleDark: () => import_legacy7.purpleDark,
  red: () => import_legacy3.red,
  redDark: () => import_legacy3.redDark,
  themes: () => import_generated_v3.themes,
  tokens: () => import_v3_themes.tokens,
  yellow: () => import_legacy5.yellow,
  yellowDark: () => import_legacy5.yellowDark
});
module.exports = __toCommonJS(v3_exports);
var import_generated_v3 = require("./generated-v3");
var import_v3_themes = require("./v3-themes");
var import_legacy = require("@tamagui/colors/legacy");
var import_legacy2 = require("@tamagui/colors/legacy");
var import_legacy3 = require("@tamagui/colors/legacy");
var import_legacy4 = require("@tamagui/colors/legacy");
var import_legacy5 = require("@tamagui/colors/legacy");
var import_legacy6 = require("@tamagui/colors/legacy");
var import_legacy7 = require("@tamagui/colors/legacy");
var import_legacy8 = require("@tamagui/colors/legacy");
//# sourceMappingURL=v3.js.map
